import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { Router, RouterLink } from '@angular/router';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ModalWithTwoButtonsComponent } from '../modals/modal-with-two-buttons/modal-with-two-buttons.component';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { HttpService } from '../../services/http.service';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { DataService } from '../../services/data.service';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { ModalAddNewRecordComponent } from '../modals/modal-add-new-record/modal-add-new-record/modal-add-new-record.component';
import { DeleteModalComponent } from '../delete-modal/delete-modal.component';
import { UserAccountDTO } from '../../classes/user-account.dto';
import { ConsultTypeService } from '../../services/consult-type.service';

@Component({
    selector: 'app-appointments-table',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NzSwitchModule,
        TranslateModule,
        NzCheckboxModule,
        NzBadgeModule,
        NzTableModule,
        NzDividerModule,
        NzGridModule,
        NzIconModule,
        NzCardModule,
        RouterLink,
        NzDropDownModule,
        NzTooltipModule,
        NzPaginationModule,
        NzModalModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [DatePipe],
    templateUrl: './appointments-table.component.html',
    styleUrl: './appointments-table.component.scss'
})
export class AppointmentsTableComponent implements OnInit, OnChanges {
  @Input() appointments: any;
  @Input() appointmentText: any;
  @Input() searchEnabled = false;
  @Input() innerFiltersEnabled = false;
  @Input() innerSelectData: any;
  @Input() hasCheckbox = false;
  @Input() columns: any;
  @Input() hiddenLastSegment: any;
  @Input() isFrom: string = '';
  @Output() actionClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() shareUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() addEmail: EventEmitter<any> = new EventEmitter<any>();
  @Output() getAppointments: EventEmitter<boolean> = new EventEmitter(false);
  isOpen: boolean = false;
  expandedRows: boolean[] = [];
  filteredAppointments: any;
  displayedAppointments: any;
  pageSize = 5;
  currentPage = 1;
  totalPages: number = 1;
  activeFilters = 0;
  searchValues = {
    commonInput: { control: new FormControl(null, [Validators.required]) },
    dateInput: {
      control: new FormControl(null, [Validators.required]),
      endControl: new FormControl(null, [Validators.required]),
      startDate: new Date('2024-05-13'),
      endDate: new Date(),
    },
  };
  dropdownOpen = false;
  allChecked = false;
  @Output() emitDeleteAction: EventEmitter<any> = new EventEmitter<any>();
  subscriptions: Array<Subscription> = [];
  opened: boolean[] = [];
  backLink: string[] = ['..'];
  isModalVisible = false;
  selectedAppointment: any = null;
  calendarUrl: string = '';
  isReportsPage = false;
  typeLabels: Record<string, string> = {};

  constructor(
    private cdr: ChangeDetectorRef,
    private modal: NzModalService,
    private translateService: TranslateService,
    private http: HttpService,
    private dataService: DataService,
    private router: Router,
    private consultTypeService: ConsultTypeService,
    public datePipe: DatePipe,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const currentUrl = this.router.url;
     this.isReportsPage = currentUrl.includes('/health-folder/reports');
    if (currentUrl.includes('/health-folder/all-history')) {
      this.backLink = ['/health-folder/medical-history'];
    }
    this.dataService.getCalendarUrl().subscribe((res) => {
      this.calendarUrl = res;
    });
     this.translate.get('type_labels').subscribe((res: any) => {
      this.typeLabels = res || {};
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appointments'] && this.appointments) {
      this.filteredAppointments = [...this.appointments];
      if (this.searchEnabled) {
        this.getSelectData();
      }
      this.calculateTotalPages();
      this.cdr.detectChanges();
    } else {
      this.filteredAppointments = [];
      this.displayedAppointments = [];
    }
  }

  getDocumentType(row: any): string {
    if (this.isReportsPage && row?.specialistNotTranslated) {
      return this.translateService.instant(`documents.category.${row.specialistNotTranslated}`);
    }
    return this.consultTypeService.getTipologia(row?.consultType);
  }

  getTypeLabel(type: string | null | undefined): string {
    if (!type) return '-';
    return this.typeLabels[type] ?? type;
  }

  getPrestazioneByContext(row: any): string {
    if (this.isReportsPage) {
      return row?.consultType ?
        this.translateService.instant(`documents.consultType.${row.consultType}`)
        : "-";
    }
    return this.consultTypeService.getPrestazione(row?.consultType);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }

  getUnit(type: string): string {
    const units: Record<string, string> = {
      bpm: 'bpm',
      weight: 'kg',
      temperature: '°C',
      glycemia: 'mg/dL',
      waistCircumference: 'cm',
      hipCircumference: 'cm',
      wristCircumference: 'cm',
      pressure: 'mmHg'
    };
    return units[type] || '';
  }

  openManageModal(appointment: any) {
    this.selectedAppointment = appointment;
    this.isModalVisible = true;
  }

  closeModal() {
    this.isModalVisible = false;
    this.selectedAppointment = null;
  }

    getTipologia(consultType: string): string {
    return this.consultTypeService.getTipologia(consultType);
  }

  getPrestazione(consultType: string): string {
    return this.consultTypeService.getPrestazione(consultType);
  }

  private getSelectData(): void {
    if (this.innerSelectData) {
      this.innerSelectData.forEach((select: any) => {
        this.subscriptions.push(select.control.valueChanges.subscribe((value: any) => this.searchBySelect(value)));
      });
    }
    this.subscriptions.push(
      this.searchValues.dateInput.endControl.valueChanges.subscribe((res) => {
        this.applyFilterTable();
      })
    );
    this.subscriptions.push(
      this.searchValues.dateInput.control.valueChanges.subscribe((res) => {
        this.applyFilterTable();
      })
    );
    this.subscriptions.push(
      this.searchValues.commonInput.control.valueChanges.subscribe((res) => {
        this.applyFilterTable();
      })
    );
  }

  toggleAccordion(index: number): void {
    this.expandedRows[index] = !this.expandedRows[index];
  }

  getBadgeStatus(status: string): string {
    switch (status) {
      case 'Confirmed':
      case 'CompletedWritten':
      case 'CompletedVideo':
      case 'CompletedPhone':
      case 'Televisit':
      case 'Erogato':
        return 'success';
      case 'Canceled':
      case 'CustomerNotAvailable':
      case 'Rejected':
      case 'SupplementaryDocumentationNeeded':
      case 'VideoCallProblemConnection':
      case 'CallDandledByJunoOperator':
        return 'error';
      case 'ReadyToAssist':
      case 'Awaiting':
      case 'DocumentsProvided':
      case 'NewProposals':
      case 'SaveNpsData':
      default:
        return 'warning';
    }
  }

  getBadgeBackground(status: string): any {
    let string = 'background-color: ';
    switch (status) {
      case 'Confirmed':
      case 'CompletedWritten':
      case 'CompletedVideo':
      case 'CompletedPhone':
      case 'Televisit':
      case 'Erogato':
        return string + '#E5F2EB;' + 'border: 1px solid #219653';
      case 'Canceled':
      case 'CustomerNotAvailable':
      case 'Rejected':
      case 'SupplementaryDocumentationNeeded':
      case 'VideoCallProblemConnection':
      case 'CallDandledByJunoOperator':
        return string + '#F8E0E5;' + 'border: 1px solid #C80226';
      case 'ReadyToAssist':
      case 'Awaiting':
      case 'DocumentsProvided':
      case 'NewProposals':
      case 'SaveNpsData':
      default:
        return string + '#FDF8E9;' + 'border: 1px solid #F2C94C';
    }
  }

  private updateActiveFilters(): void {
    let count = 0;
    if (this.searchValues.commonInput.control.value) {
      count++;
    }
    const startDate = this.searchValues.dateInput.control.value;
    const endDate = this.searchValues.dateInput.endControl.value;
    if (startDate && endDate) {
      count++;
    }
    if (this.innerSelectData) {
      this.innerSelectData.forEach((select: any) => {
        if (select.control.value && select.control.value !== 'Tutti') {
          count++;
        }
      });
    }
    this.activeFilters = count;
  }

  applyFilterTable() {
    const searchString: string = this.searchValues.commonInput.control.value ? this.searchValues.commonInput.control.value : '';

    const dateRange =
      this.searchValues.dateInput.endControl.value && this.searchValues.dateInput.control.value
        ? [new Date(this.searchValues.dateInput.control.value), new Date(this.searchValues.dateInput.endControl.value)]
        : null;

    if (!searchString && !dateRange) {
      this.filteredAppointments = this.appointments;
      this.cdr.detectChanges();
    }

    if (searchString) {
      this.filteredAppointments = this.appointments.filter((appointment: any) => this.searchByString(searchString, appointment));
    }

    if (dateRange) {
      this.filteredAppointments = this.filteredAppointments.filter((appointment: any) => {
        const appointmentDate = this.parseCustomDate(appointment.date ? appointment.date : appointment.consultDate);
        if (isNaN(appointmentDate.getTime())) {
          return false;
        }

        return (
          formatDate(appointmentDate, 'yyyy-MM-dd', 'it_IT') >= formatDate(new Date(dateRange[0]), 'yyyy-MM-dd', 'it_IT') &&
          formatDate(appointmentDate, 'yyyy-MM-dd', 'it_IT') <= formatDate(new Date(dateRange[1]), 'yyyy-MM-dd', 'it_IT')
        );
      });
    }
    this.calculateTotalPages();
    this.updateActiveFilters();
    this.cdr.detectChanges();
  }

  private searchBySelect(searchString: any) {
    if (searchString === 'Tutti' || !searchString) {
      this.filteredAppointments = this.appointments;
    } else {
      this.filteredAppointments = this.appointments.filter((appointment: any) => {
        return this.searchByString(searchString, appointment);
      });
    }
    this.updateActiveFilters();
    this.calculateTotalPages();
    this.cdr.detectChanges();
  }

  private parseCustomDate(dateString: any) {
    const dateSplitted = dateString.split('T')[0];
    if (dateSplitted.includes('/')) {
      const parts = dateSplitted.includes('/') ? dateSplitted.split('/') : dateSplitted.split('-');
      return new Date(parts[2], parts[1] - 1, parts[0]);
    }
    return new Date(dateSplitted);
  }

  searchByString(searchString?: any, appointment?: any) {
    if (searchString && appointment) {
      return (
        !searchString.toLowerCase() ||
        appointment?.value?.toString().toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.name?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.consultType?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.specialist?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.fullName?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.statusText?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.fullNamePayment?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.course?.toLowerCase().includes(searchString.toLowerCase()) ||
        appointment?.service?.toLowerCase().includes(searchString.toLowerCase())
      );
    }
  }

  openDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  public emitClick(user: any) {
    this.actionClicked.emit(user);
  }

  public triggerDropdown(event: Event): void {
    event.preventDefault();
    (event.currentTarget as HTMLElement | null)?.click();
  }

  public emitShare(user: any) {
    this.shareUser.emit(user);
  }

  public addEmailEmit(user: any) {
    this.addEmail.emit(user);
  }

  public openHandleModal(){
    this.modal.create({

    })
  }

    toggleEditMode(appointment: any): void {
      const token = localStorage.getItem('authToken')?.replaceAll('"', '');
      const today = new Date();
      const body = {
        dossierCode: appointment.dossierCode,
        language: 'it',
        startingMonth: today.getUTCMonth() + 1,
        startingYear: today.getFullYear(),
        token: token,
        primaryProvision: null,
        activityCode: null,
      };

      this.http.getCalendarDatesByModify(body, this.calendarUrl).subscribe((res) => {
        if (res) {
          this.dataService.setDatesByModify(res);
          localStorage.setItem('appointment', JSON.stringify(appointment));
          const redirect = this.getRedirect(appointment.consultType);
          this.router.navigate([`/medical-consultations/${redirect}/modify`]);
        }
      });
    }

  private getRedirect(consultType: string) {
    switch (consultType) {
      case 'GenericTelevisitPhone':
      case 'GenericTelevisitVideo':
        return 'televisit-generic-booking';
      case 'SpecialistTelevisitPhone':
      case 'SpecialistTelevisitVideo':
        return 'televisit-specialist-booking';
      case 'GenericVideo':
      case 'GenericPhone':
        return 'generic-consultation';
      case 'SpecialistVideo':
      case 'SpecialistPhone':
        return 'specialist-consultation';
      case 'PsychologistVideo':
      case 'PsychologistPhone':
        return 'psyco-pathway';
      case 'TreatmentPathNutTelevisit':
        return 'nut-pathway';
      case 'CareManager':
        return 'care-manager';
      case 'VeterinarianPhone':
      case 'VeterinarianVideo':
        return 'vet-consultation';
      default:
        return;
    }
  }

  deleteAppointment(appointment: any): void {
    const textsModal = this.translateService.instant('deleteAppointmentModal');
    const activeModal = this.modal.create({
      nzContent: ModalWithTwoButtonsComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          colorActionButton: 'red',
          texts: {
            ...textsModal,
            first_button_pointer: 'delete',
          },
          actionButton: () => {
            this.http.deleteAppointment(appointment.individualId, appointment.dossierCode, appointment.missionId, appointment.consultType).subscribe((res) => {
              if (res) {
                activeModal.close();
                this.isModalVisible = false;
                this.getAppointments.emit(true);
              }
            });
          },
        },
      },
    });
  }

  public openModal(connectionId: string, profileName: string): void {
    const title = this.translateService.instant('deleteUserModal.title');
    const content = this.translateService.instant('deleteUserModal.content', { name: profileName });
    this.modal.create({
      nzContent: ModalWithTwoButtonsComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          colorActionButton: 'red',
          texts: {
            title,
            content,
            first_button_pointer: 'delete',
          },
          actionButton: () => this.handleActionDeleteUser(connectionId),
        },
      },
    });
  }

  private handleActionDeleteUser(connectionId: any) {
    this.dataService.companyId$.subscribe((companyId) => {
      this.http.deleteUser(connectionId, companyId!).subscribe((res) => {
        this.modal.closeAll();
        this.emitDeleteAction.emit(connectionId);
      });
    });
  }

  onSelectAll(checked: boolean): void {
    this.filteredAppointments.forEach((item: any) => (item.checked = checked));
  }

  onRowSelectionChange(data: any): void {
    this.allChecked = this.filteredAppointments.every((item: any) => item.checked);
    const selectedData = this.filteredAppointments.filter((item: any) => item.checked);
  }

  public getIconUrl(course: string): string {
    switch (course) {
      case 'positivo':
        return '../../../../public/assets/images/arrowUp.svg';
      case 'negativo':
        return '../../../../public/assets/images/arrowDown.svg';
      default:
        return '-';
    }
  }

  public downloadFile(data: any, toDownload: boolean, index: any) {
    if (data) {
      this.http.downloadSingleDocument(data.individualId, data.docName, toDownload).subscribe((res) => {
        if (res) {
          const link = document.createElement('a');
          link.href = res.docUrl;
          link.download = data.docName;
          link.click();
        }
      });
      this.opened[index] = false;
      this.cdr.detectChanges();
    }
  }

  public viewFile(data: any, index: any) {
    if (data) {
      this.http.viewDocument(data.docName, data.individualId).subscribe((res: any) => {
        const blob = new Blob([res], { type: 'image/png' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener');
      });
      this.opened[index] = false;
      this.cdr.detectChanges();
    }
  }

  public deleteFile(data: any, index: any) {
    const textsModal = this.translateService.instant('deleteDocumentModal');
    const activeModal = this.modal.create({
      nzContent: ModalWithTwoButtonsComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {
          colorActionButton: 'red',
          texts: { ...textsModal, first_button_pointer: 'delete' },
          actionButton: () => {
            activeModal.close();
            data.eventType = 'delete';
            this.opened[index] = false;
            this.cdr.detectChanges();
            this.actionClicked.emit(data);
          },
        },
      },
    });
  }

  hasField(field: keyof any): boolean {
    return this.filteredAppointments.some((d: any) => d[field] !== undefined && !d.isEmpty);
  }

  calculateTotalPages(): void {
    if (!this.filteredAppointments || this.filteredAppointments.length === 0) {
      this.totalPages = 1;
    } else {
      this.totalPages = Math.ceil(this.filteredAppointments.length / this.pageSize);
    }
    this.currentPage = 1;
    this.updateDisplayedData();
  }

  onPageChange(page: any): void {
    this.totalPages = Math.ceil(this.filteredAppointments.length / this.pageSize);
    this.currentPage = Math.min(Math.max(1, page), this.totalPages);
    this.updateDisplayedData();
    this.cdr.detectChanges();
  }

  updateDisplayedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    if (start >= this.filteredAppointments.length) {
      this.currentPage = Math.max(1, this.totalPages);
    }
    this.displayedAppointments = this.filteredAppointments.slice(start, end);
    this.cdr.detectChanges();
  }

  redirectAppointmentsDetail(consultRequestId: number) {
    this.router.navigate(['/medical-consultations/appointments-detail/' + consultRequestId]);
  }

  editRecord(record: any, item: any): void {
    const modalRef = this.modal.create({
      nzContent: ModalAddNewRecordComponent,
      nzData: {
        key: record,
        initialData: {
          ...item,
          underTherapy: item.underTherapy || false,
          specificAllergen: item.type ? item.specificAllergen : null,
          drugFormat: item.type ? item.drugFormat : null,
          posology: item.dose || null,
          doseMeasureUnit: item.doseMeasureUnit || null,
          dose: item.posology || null,
          posologyFrequence: item.posologyFrequence || null,
          revaccinationDate: item.revaccinationDate || null,
          revaccination: item.revaccination || false,
        },
      },
      nzFooter: null,
    });

    modalRef.afterClose.subscribe((updatedRecord) => {
      this.actionClicked.emit(true);
    });
  }

  deleteRecord(record: any, item: any): void {
    const userData = JSON.parse(localStorage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData.individualId;

    if (!item) {
      console.error('Errore: Payload non valido per', record.key);
      return;
    }

    this.http.deleteMedicalRecord(record, individualId, item).subscribe({
      next: () => {
        this.actionClicked.emit(true);
      },
      error: (error) => {
        console.error("Errore durante l'eliminazione:", error);
      },
    });
  }

  delete(record: any, item: any): void {
    const modalRef = this.modal.create({
      nzTitle: 'Elimina valore',
      nzContent: DeleteModalComponent,
      nzData: { message: `Confermi di voler eliminare il valore di ${item.type || 'questo record'}?` },
      nzFooter: null,
    });

    modalRef.afterClose.subscribe((confirmed) => {
      if (confirmed) {
        this.deleteRecord(record, item);
      }
    });
  }

  getType(consultType: string): string {
    return this.consultTypeService.getTipologia(consultType);
  }

  getPrestation(consultType: string): string {
    return this.consultTypeService.getPrestazione(consultType);
  }

    public convertDate(date: string, isDate: boolean): string {
      if (date && isDate) {
        return this.datePipe.transform(date, 'dd/MM/yyyy')!;
      } else if (date && !isDate) {
        return this.datePipe.transform(date, 'HH:mm')!;
      }
      return '';
    }
}
